import { createContext, useCallback, useState } from 'react';
import { wrap } from '@hilma/tools';
export var IsAlertOpenContext = createContext(null);
export var AlertTextContext = createContext(null);
export var AlertTypeContext = createContext(null);
export var AlertContext = createContext(null);
var AlertProvider = function (_a) {
    var children = _a.children;
    var isOpenTuple = useState(false), setIsOpen = isOpenTuple[1];
    var textTuple = useState(''), setText = textTuple[1];
    var typeTuple = useState('error'), setType = typeTuple[1];
    var alert = useCallback(function (text, type) {
        if (type === void 0) { type = 'error'; }
        setIsOpen(true);
        setText(text);
        setType(type);
    }, []);
    return wrap([IsAlertOpenContext.Provider, { value: isOpenTuple }], [AlertTextContext.Provider, { value: textTuple }], [AlertTypeContext.Provider, { value: typeTuple }], [AlertContext.Provider, { value: alert }])(children);
};
export default AlertProvider;
//# sourceMappingURL=AlertProvider.js.map